<template>
  <div class="desktop screen">
    <div class="bread_crumbs">
      <div class="bread_crumbs-item" @click="clickBreadCrumbs">
        <div class="equipos">Equipos – Seleccionar equipo</div>
      </div>
      <div class="text-1">/</div>
      <div class="bread_crumbs-item">
        <div class="perfil-equipo">Perfil equipo</div>
      </div>
    </div>
    <header class="header">
      <div class="header_container">
        <div class="player_data">
          <div class="escudo_equipo">
            <img class="logo_equipo" v-if="image" :src="image" alt="logo_equipo" />
          </div>
          <div class="info">
            <div class="info_container">
              <div class="name">
                <h1 class="title valign-text-middle">{{ team.team_name }}</h1>
              </div>
            </div>
            <div class="puntos" v-if="points && seasonType === 0 && ![1784, 1741, 1512, 881].includes(selectedSeason)">
              <div class="address valign-text-middle avenirnextltpro-regular-normal-white-37-4px">
                <span
                  ><span class="avenirnextltpro-regular-normal-white-37-4px">{{ points }}</span
                  ><span class="span1">&nbsp;</span><span class="span2"> PTS</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="header_info_menu">
          <div class="btn" :class="value === 4 ? 'active' : ''" @click="onChangeSection(4)">
            <img
              class="icon-clock"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen@2x.png"
              alt="icon-clock"
            />
            <div class="resumen valign-text-middle avenirnextltpro-demi-normal-white-11-6px">RESUMEN</div>
          </div>
          <div
            class="btn"
            v-on:mouseover="isHover = true"
            v-on:mouseleave="isHover = false"
            :class="value === 1 ? 'active' : ''"
            @click="onChangeSection(1)"
          >
            <img
              v-if="!isHover && value != 1"
              class="icn_posesion"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_normal@2x.png"
              alt="icn_posesion"
            />
            <img v-else class="icn_posesion" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_hover@2x.png" />
            <div class="posesin valign-text-middle avenirnextltpro-demi-normal-white-11-6px">POSESIÓN</div>
          </div>
          <div class="btn" :class="value === 2 ? 'active' : ''" @click="onChangeSection(2)">
            <img class="icn" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_ofensivo@2x.png" alt="icn_ofensivo" />
            <div class="ofensivo valign-text-middle avenirnextltpro-demi-normal-white-11-6px">OFENSIVO</div>
          </div>
          <div class="btn" :class="value === 3 ? 'active' : ''" @click="onChangeSection(3)">
            <img class="icn" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_defensivo@2x.png" alt="icn_defensivo" />
            <div class="defensivo valign-text-middle avenirnextltpro-demi-normal-white-11-6px">DEFENSIVO</div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Desktop',
  props: {
    points: {
      type: Number,
      required: false,
      default: 0,
    },
    team: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      isHover: false,
      section: 4,
      selectedSeason: 0,
      sections: [
        {
          id: 4,
          title: 'analysis_type.summary',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen_unselected.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen.svg',
          ],
          selected: false,
        },
        {
          id: 1,
          title: 'analysis_type.possession',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-white.svg',
          ],
          selected: false,
        },
        {
          id: 2,
          title: 'analysis_type.offensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-white.svg',
          ],
          selected: false,
        },
        {
          id: 3,
          title: 'analysis_type.defensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-white.svg',
          ],
          selected: false,
        },
      ],
    };
  },
  watch: {
    value(newId) {
      this.changeSection(newId);
    },
  },
  computed: {
    ...mapState('filterGeneral', ['seasonType']),
    sectionsIds() {
      return this.sections.map(i => i.id);
    },
    image() {
      if (this.team.logo) {
        return `https://golstatsimages.blob.core.windows.net/teams-150/${this.team.logo.split('/').pop()}`;
      } else {
        return '';
      }
    },
  },
  methods: {
    clickBreadCrumbs() {
      this.$router.push('/teamsAnalysis/teams');
    },
    changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(e => (e.selected = false));
        const section = this.sections.find(s => s.id === sectionId);
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection(id) {
      this.section = id;
      let result = this.changeSection(id);
      if (result) this.$emit('input', id);
    },
  },
  mounted() {
    this.changeSection(this.value);
  },
  created() {
    const selectedSeason = window.localStorage.getItem('seasonSelected');
    if (selectedSeason) {
      this.selectedSeason = Number(selectedSeason);
    }
  },
};
</script>

<style>
.headerfigmaTeams .active {
  background-color: #23b0ff !important;
}
.headerfigmaTeams .desktop {
  align-items: flex-start;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  position: relative;
  margin-top: -14px;
}

.headerfigmaTeams .bread_crumbs {
  align-items: center;
  display: flex;
  justify-content: left;
  padding: 0px 0px 0px 7.74px;
  position: relative;
  width: 1270px;
  margin: 0 auto;
}

.headerfigmaTeams .bread_crumbs-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 19.35px;
  padding: 3.87px 7.74px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .equipos {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-xxxxl);
  font-weight: 500;
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}
.headerfigmaTeams .equipos:hover {
  color: #23b0ff;
  cursor: pointer;
}

.headerfigmaTeams .text-1 {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxxxl);
  font-weight: 400;
  letter-spacing: -0.19px;
  line-height: 32.9px;
  opacity: 0.4;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .perfil-equipo {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xxxxl);
  font-weight: 700;
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .header {
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
    180deg,
    rgb(6.85, 91.11, 137.06) 0%,
    rgba(1.63, 68.84, 105.5, 1) 51.8%,
    rgba(1.42, 14.25, 21.25, 1) 100%
  );
  background-color: transparent;
  border-radius: 15.87px;
  display: flex;
  gap: 9.33px;
  height: 197px;
  mix-blend-mode: normal;
  padding: 7.74px 23.23px 13.07px;
  position: relative;
}

.headerfigmaTeams .header_container {
  align-items: flex-start;
  display: flex;
  flex: 1;
  justify-content: space-between;
  position: relative;
}

.headerfigmaTeams .player_data {
  align-items: flex-start;
  display: flex;
  gap: 27.1px;
  height: 131.12px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .escudo_equipo {
  align-items: center;
  display: flex;
  gap: 10px;
  height: 131.12px;
  justify-content: flex-end;
  position: relative;
  width: 125.32px;
}

.headerfigmaTeams .logo_equipo {
  height: 129px;
  margin-bottom: -2.94px;
  margin-right: -4px;
  min-width: 129px;
  object-fit: cover;
  position: relative;
}

.headerfigmaTeams .info {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 113px;
  justify-content: space-between;
  /* padding: 7.87px 0px 0px; */
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .info_container {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 15.87px;
  height: 42.15px;
  position: relative;
}

.headerfigmaTeams .name {
  align-items: flex-start;
  display: flex;
  gap: 19.35px;
  margin-bottom: 20.47px;
  padding: 5.81px 0px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .title {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xxxxxl);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 38.7px;
  margin-top: -1.94px;
  position: relative;
  text-shadow: 0px 3.73px 3.73px #162b3436;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .puntos {
  align-items: center;
  border: 2.08px solid;
  border-color: var(--white-2);
  border-radius: 16.63px;
  display: flex;
  gap: 20.79px;
  justify-content: center;
  padding: 4px 20.79px 6px;
  position: relative;
  width: fit-content;
  margin-top: 22px;
}

.headerfigmaTeams .address {
  letter-spacing: -1.12px;
  line-height: 40.1px;
  margin-top: -2.08px;
  position: relative;
  text-shadow: 0px 4.01px 4.01px #162b3436;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .span1 {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: 50.1px;
  font-weight: 700;
  letter-spacing: -1.5px;
}

.headerfigmaTeams .span2 {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: 24.9px;
  font-weight: 500;
  letter-spacing: -0.75px;
}

.headerfigmaTeams .header_info_menu {
  align-items: center;
  align-self: stretch;
  border-radius: 11.2px;
  display: flex;
  gap: 11.61px;
  justify-content: flex-end;
  position: relative;
  width: 562.84px;
}

.headerfigmaTeams .btn {
  align-items: center;
  border-radius: 10.27px;
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 13.55px;
  height: 86px;
  justify-content: center;
  padding: 9.68px 0px;
  position: relative;
  transition: all 0.2s ease;
  box-shadow: 0 0.9px 4.7px 0 rgba(27, 45, 63, 0.14);
  border: solid 0.9px #23b0ff;
}

.headerfigmaTeams .btn:hover {
  background-color: #23b0ff;
}

.headerfigmaTeams .icon-clock {
  height: 45.73px;
  margin-top: -0.32px;
  min-width: 45.73px;
  position: relative;
}

.headerfigmaTeams .resumen,
.headerfigmaTeams .posesin,
.headerfigmaTeams .ofensivo,
.headerfigmaTeams .defensivo {
  letter-spacing: -0.35px;
  line-height: 7.7px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .btn_radiografia {
  align-items: center;
  border: 0.93px solid;
  border-color: var(--white);
  border-radius: 10.27px;
  box-shadow: 0px 0.93px 4.67px #1a2d3e24;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 13.55px;
  justify-content: center;
  padding: 9.68px 0px;
  position: relative;
}

.headerfigmaTeams .icn_radiografia {
  height: 45.73px;
  min-width: 45.73px;
  position: relative;
}

.headerfigmaTeams .radiografa {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: 11.2px;
  font-weight: 400;
  letter-spacing: -0.34px;
  line-height: 7.7px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .icn_posesion {
  height: 45.73px;
  margin-top: -0.32px;
  min-width: 71.92px;
  position: relative;
}

.headerfigmaTeams .icn {
  height: 46.11px;
  margin-top: -0.69px;
  min-width: 73.42px;
  position: relative;
}
</style>
